import request from '..'

export const getCustomerList = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/list',
        method: 'get',
        params
    })
}

export const addCustomer = (data: any): Promise<any> => {
    return request({
        url: '/v2/customer/add',
        method: 'post',
        data
    })
}

export const updateCustomer = (data: any): Promise<any> => {
    return request({
        url: '/system/user',
        method: 'put',
        data
    })
}

export const getCustomerBaseInfoById = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/baseInfo',
        method: 'get',
        params
    })
}

export const getCustomerCardList = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/card/list',
        method: 'get',
        params
    })
}

export const getCustomerCardDetail = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/card/detail',
        method: 'get',
        params
    })
}

export const getCustomerCouponList = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/coupon/list',
        method: 'get',
        params
    })
}

export const getCustomerCouponDetail = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/coupon/detail',
        method: 'get',
        params
    })
}

export const deleteCouponById = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/coupon/delete',
        method: 'get',
        params
    })
}

export const getCustomerData = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/data',
        method: 'get',
        params
    })
}

export const getCustomerCardDetailContent = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/card/detail/content',
        method: 'get',
        params
    })
}

export const getCustomerCardDetailConsume = (params: any): Promise<any> => {
    return request({
        url: '/v2/customer/card/detail/consume',
        method: 'get',
        params
    })
}










